import {Licenses} from '../../interfaces/core/licenses';

export class LicensesFactory {
  /**
   *
   * @param licenses
   */
  public static fromObject(licenses: any): Licenses {
    return new class implements Licenses {
      careDocumentation: boolean = licenses.care_documentation;
      customerDocuments: boolean = licenses.customer_documents;
      planningRoster: boolean = licenses.planning_roster;
      identityCards: boolean = licenses.identity_cards;
      instructions: boolean = licenses.instructions;
      masterData: boolean = licenses.master_data;
      operatingPlan: boolean = licenses.operating_plan;
      products: boolean = licenses.products;
      timeTracking: boolean = licenses.time_tracking;
      employeeDocuments: boolean = licenses.employee_documents;
      processReports: boolean = licenses.process_reports;
    };
  }

  /**
   *
   */
  public static new(): Licenses {
    return new class implements Licenses {
      careDocumentation: boolean = false;
      customerDocuments: boolean = false;
      planningRoster: boolean = false;
      identityCards: boolean = false;
      instructions: boolean = false;
      masterData: boolean = false;
      operatingPlan: boolean = false;
      products: boolean = false;
      timeTracking: boolean = false;
      employeeDocuments: boolean = false;
      processReports: boolean = false;
    };
  }
}
